export default __webpack_public_path__ + "static/media/pricing-settings-welcome.29fd9c47.png";